module.exports = __webpack_public_path__ + "assets/img/AppIcon.88518223.png";